import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateLong'
})
export class DateLongPipe implements PipeTransform {
  transform(value: string | Date): string {
    if (!value) return '';

    const date = new Date(value);
    const day = date.getDate();
    const year = date.getFullYear();
    const monthNames = [
      'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
      'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
    ];
    const month = monthNames[date.getMonth()];

    return `${day} de ${month} del ${year}`;
  }
}
